/**  This code is using GQuery to attach an event handler to the window's "load" event. When the window
finishes loading, the code checks if a modal has been displayed before by retrieving the value of
the "golo-error" key from the localStorage. If the modal has not been displayed (the value is null
or "false"), it shows the modal with the id "ViewErrorModal" using the gQuery modal method
"modal('show')". 
The code below is being used in conjunction with {% section 'mygolo-error-message' %}
*/
$(window).on("load", () => {
  const modalHasBeenDisplayed = localStorage.getItem("golo-error");
  if (!modalHasBeenDisplayed || modalHasBeenDisplayed === "false") {
    $("#ViewErrorModal").modal("show");
    document.addEventListener("shown.bs.modal", function () {
      //only set the item once the modal has been shown and the shown.bs.modal event has been emitted.
      localStorage.setItem("golo-error", true);
    });
  }
});
